import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";

import { AdminRoute, ProtectedRoute } from "@/components/protected-route";
import { RouteFallback } from "@/components/route-fallback";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { SignupPage } from "@/features/signup";
import { VerifyEmailPage } from "@/features/verify-email";

const SimulatorPage = lazy(() =>
  import("@/features/simulator").then((m) => ({ default: m.SimulatorPage })),
);
const ProfilePage = lazy(() =>
  import("@/features/profile").then((m) => ({ default: m.ProfilePage })),
);
const AdminUsersPage = lazy(() =>
  import("@/features/admin/users").then((m) => ({ default: m.AdminUsersPage })),
);
const AdminActivityPage = lazy(() =>
  import("@/features/admin/activity").then((m) => ({
    default: m.AdminActivityPage,
  })),
);

export function App() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/home" element={<SimulatorPage />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Route>
        <Route element={<AdminRoute />}>
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/activity" element={<AdminActivityPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
